// @ts-strict-ignore
import {DateRange, DateRangeAttributes} from 'common/widgets/date-range-picker/models/date-range';
import {PropertyFilterDateRange} from 'common/widgets/date-range-picker/models/property-filter-date-range';

import {PropertyFilter} from './property-filter';

export class DefaultPropertyFilter extends PropertyFilter {
  public createDateRange(attributes: Partial<DateRangeAttributes> = {}): DateRange {
    return new PropertyFilterDateRange(attributes);
  }
}
